import { BidiModule } from '@angular/cdk/bidi';
import * as i0 from '@angular/core';
import { NgModule } from '@angular/core';
import { MatRippleModule } from './_ripple-module-chunk.mjs';
import { MatPseudoCheckboxModule } from './_pseudo-checkbox-module-chunk.mjs';
import { MatOption, MatOptgroup } from './_option-chunk.mjs';
let MatOptionModule = /*#__PURE__*/(() => {
  class MatOptionModule {
    static ɵfac = function MatOptionModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || MatOptionModule)();
    };
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: MatOptionModule
    });
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [MatRippleModule, MatPseudoCheckboxModule, MatOption, BidiModule]
    });
  }
  return MatOptionModule;
})();
/*#__PURE__*/(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
export { MatOptionModule };
